import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const pickEnv = (...keys) =>
  keys.map((key) => process.env[key]).find((value) => Boolean(value));

const firebaseConfig = {
  apiKey: pickEnv(
    "REACT_APP_FIREBASE_API_KEY",
    "REACT_APP_APIKEY",
    "REACT_APP_APIKAY",
  ),
  authDomain: pickEnv("REACT_APP_FIREBASE_AUTH_DOMAIN", "REACT_APP_AUTHDOMAIN"),
  projectId: pickEnv("REACT_APP_FIREBASE_PROJECT_ID", "REACT_APP_PROJECTID"),
  storageBucket: pickEnv(
    "REACT_APP_FIREBASE_STORAGE_BUCKET",
    "REACT_APP_STORAGEBUCKET",
  ),
  messagingSenderId: pickEnv(
    "REACT_APP_FIREBASE_MESSAGING_SENDER_ID",
    "REACT_APP_MESSAGESENDERID",
    "REACT_APP_MESSAGE_SENDERID",
  ),
  appId: pickEnv("REACT_APP_FIREBASE_APP_ID", "REACT_APP_APPID"),
  measurementId: pickEnv(
    "REACT_APP_FIREBASE_MEASUREMENT_ID",
    "REACT_APP_MEASUREMENT_ID",
  ),
};

const requiredKeys = [
  "apiKey",
  "authDomain",
  "projectId",
  "storageBucket",
  "appId",
];
const missingKeys = requiredKeys.filter((key) => !firebaseConfig[key]);

let app;
let auth;
let db;
let storage;
let appCheck;

if (missingKeys.length === 0) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);

  const appCheckSiteKey = pickEnv(
    "REACT_APP_FIREBASE_RECAPTCHA_SITE_KEY",
    "REACT_APP_FIREBASE_RECAPTCHA_PUBLIC_KEY",
    "REACT_APP_CAPTCHA_PUBLIC_KEY",
  );

  if (
    typeof window !== "undefined" &&
    process.env.NODE_ENV !== "test" &&
    appCheckSiteKey
  ) {
    const debugToken = pickEnv("REACT_APP_APPCHECK_DEBUG_TOKEN");
    if (debugToken && process.env.NODE_ENV === "development") {
      window.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
    }

    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(appCheckSiteKey),
      isTokenAutoRefreshEnabled: true,
    });
  }
} else if (
  process.env.NODE_ENV !== "production" &&
  process.env.NODE_ENV !== "test"
) {
  // eslint-disable-next-line no-console
  console.warn(
    "Firebase configuration incomplete. Missing keys:",
    missingKeys.join(", "),
  );
}

export const isFirebaseConfigured = missingKeys.length === 0;

export { app, auth, db, storage, appCheck };
